import {Controller} from "stimulus"
import AutoNumeric from "autonumeric";

let autoNumericList = [];

var delayTimer;
export default class extends Controller {

    connect() {
        console.log("log from cem-contracts controller");

        autoNumericList = new AutoNumeric.multiple(".tendered-field", ['NorthAmerican', {unformatOnSubmit: true}]);


        // Hide contact method select if present
        const contactMethodSelect = document.querySelector(".contact-method-select");
        if (contactMethodSelect) {
            contactMethodSelect.classList.add('hidden');
        }

        // Update signee address header if present
        const contactMethodSet = document.querySelector(".contact-method-set");
        if (contactMethodSet) {
            const header = contactMethodSet.querySelector("h4");
            if (header) header.innerText = 'Signee Address';
        }
    }

}
